"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classnames_1 = __importDefault(require("classnames"));
var classNamesDefault = function (props) {
  return (0, classnames_1.default)(props.className, props.variant && "ap-".concat(props.variant), props.disabled && "ap-disabled", props.size && "ap-".concat(props.size), props.fluid && "ap-fluid", props.error && "ap-error", props.round && "ap-round");
};
exports.default = classNamesDefault;